import { Col } from "react-bootstrap";
import React from "react";

export const PageTitleController = ({ title, icon = null }) => {
  return (
    <Col className={"icon-text-wrapper mb-3"}>
      <h2 className={"text-axis-offblack text-axis-title icon-text-wrapper"}>
        {icon} {title}
      </h2>
    </Col>
  );
};
